import React from 'react';
import { UIHeading2, UIHeading3, Image, UIText1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import styles from './styles.css';

/**
 * Карточка контакта в футере с QR изображением
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FooterQRContactCard = function FooterQRContactCard(_ref) {
  var qrCodeSrc = _ref.qrCodeSrc,
    title = _ref.title,
    description = _ref.description,
    href = _ref.href,
    onQrCodeClick = _ref.onQrCodeClick;
  var deviceType = useDeviceType();
  var isDesktop = deviceType === 'desktop';
  var TitleComponent = isDesktop ? UIHeading2 : UIHeading3;
  return /*#__PURE__*/_jsxs("article", {
    className: cn(styles['container'], styles[deviceType]),
    children: [isDesktop && /*#__PURE__*/_jsx("a", {
      href: href,
      target: "_blank",
      rel: "noopener noreferrer",
      tabIndex: -1,
      className: styles['qr-image-link'],
      onClick: onQrCodeClick,
      children: /*#__PURE__*/_jsx(Image, {
        src: qrCodeSrc,
        width: 88,
        height: 88,
        loading: "lazy"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['text-content'],
      children: [/*#__PURE__*/_jsx(TitleComponent, {
        whiteSpace: "pre-line",
        children: title
      }), /*#__PURE__*/_jsx(UIText1, {
        whiteSpace: "pre-line",
        children: description
      })]
    })]
  });
};